module.exports = "/images/home_section_cover_crop.jpg?1550c2d440af96ac2589a210e52afd04";